export const websterRankingsDataAPI = process.env.REACT_APP_WEBSTER_RANKINGS_DATA_API|| "";
export const droidrushRankingsDataAPI = process.env.REACT_APP_DROIDRUSH_RANKINGS_DATA_API || "";
export const logicalrhythmRankingsDataAPI = process.env.REACT_APP_LOGICALRHYTHM_RANKINGS_DATA_API || "";
export const softablitzRankingsDataAPI = process.env.REACT_APP_SOFTABLITZ_RANKINGS_DATA_API|| "";